import isStreamMonkey from '../../utils/isStreamMonkey';

export default class CompleteMigrationController {
  constructor($rootScope, $state, $scope, $http, User, Account, $location) {
    'ngInject';
    this.rootScope = $rootScope;
    this.account = $rootScope.account;
    this.accountInfo = Account.getBilling();
    this.user = User;
    this.$state = $state;
    this.$location = $location;
    this.$http = $http;
    this.numVideos = 0;
    $rootScope.videoSetup = false;
    this.isStreamMonkey = isStreamMonkey(this.account.migration_service_id);

    this.tabArr = [
      'welcome',
      'account-info',
      'video-organization',
      'migration-progress',
      'plan-enrollment',
      'success',
    ];
    this.tabIndex = this.tabArr.findIndex(
      (element) => element == $location.$$path.substring($location.$$path.lastIndexOf('/') + 1)
    );

    this.$http.get(`${API_ROOT}/account/migration/imports`).then((resp) => {
      this.numVideos = resp.data.length;
    });

    if (this.account.status != 'onboarding') {
      this.$state.go('complete-migration.success');
    }

    let activeTab =
      this.$state.current.name.split('.')[1] || localStorage.getItem('activeTab') || 'welcome';
    this.switchTab(activeTab);

    $rootScope.$on('account-migrated', (event, state) => {
      this.account.status = state.status;
      this.$state.go('complete-migration.success');
    });

    var deregisterLocation = $rootScope.$on('$locationChangeSuccess', (evt, newUrl, oldUrl) => {
      if (
        !this.tabArr.includes(oldUrl.substring(oldUrl.lastIndexOf('/') + 1)) &&
        newUrl.substring(newUrl.lastIndexOf('/') + 1) == 'plan-enrollment'
      ) {
        const { rootScope } = this;
        rootScope.$emit('open-sm-modal');
      }
    });

    var deregisterState = $rootScope.$on('$stateChangeStart', (event, toState) => {
      const tab = toState.name.split('.')[1] || 'welcome';
      this.tabIndex = this.tabArr.findIndex((element) => element == tab);
    });

    var deregisterCheck = $rootScope.$on('checkValidation', function (event, data) {
      $rootScope.videoSetup = data;
    });

    $scope.$on('$destroy', function destroyScope() {
      deregisterState();
      deregisterLocation();
      deregisterCheck();
    });
  }

  openCompleteAccountModal() {
    const { rootScope } = this;
    rootScope.$emit('open-sm-modal');
    // the modal instance lives in top-navbar.js
  }

  nextTab() {
    this.tabIndex++;
    this.switchTab(this.tabArr[this.tabIndex], true);
  }

  prevTab() {
    this.tabIndex--;
    this.switchTab(this.tabArr[this.tabIndex], true);
  }

  switchTab(tab, checkClick) {
    this.tabIndex = this.tabArr.findIndex((element) => element == tab);
    localStorage.setItem('activeTab', tab);
    this.$state.go(`complete-migration.${this.tabArr[this.tabIndex]}`);
    if (tab == 'plan-enrollment' && checkClick) {
      this.openCompleteAccountModal();
    }
  }
}



// WEBPACK FOOTER //
// ./app/pages/complete-migration/complete-migration.js